import React from 'react';

import { Label } from '@eika/label';

interface Props {
    className?: string;
    labels?: ReturnType<typeof Label>[] | ReturnType<typeof Label>;
}

const Labels: React.FC<Props> = ({ className = 'sgw-link-list-item__label', labels }) =>
    labels ? <span className={className}>{labels}</span> : null;

export default Labels;
